import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "reactstrap";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { useForm } from "react-hook-form";

const EditSalaryModal = ({
  show,
  onClose,
  onUpdate,
  isLoading = false,
  siteSalaryDetails,
}) => {
  const [salary, setSalary] = useState([]);
  const [isLoadingUserSalary, setIsLoadingUserSalary] = useState(false);

  const {
    register: registerSalary,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors: errorsSalary },
  } = useForm({
    defaultValues: {
      userSalary: [],
    },
  });

  useEffect(() => {
    if (show && siteSalaryDetails?.userId) {
      GetUserSalary(siteSalaryDetails.userId);
    }
  }, [show, siteSalaryDetails?.userId]);

  const GetUserSalary = async (userId) => {
    setIsLoadingUserSalary(true);
    let options = {
      method: "GET",
    };
    const Url = apiUrl.get_user_salary + `?userId=${userId}`;
    const res = await callApi(Url, options);
    if (res?.status === true && res.data?.length > 0) {
      const isOfficeStaff = res.data.some(i => i?.officesalaryhead);
      const firstItem = res.data[0];
      const headRelation = firstItem?.officesalaryhead || firstItem?.sitesalaryhead;
      const siteId = headRelation?.siteId;

      // Fetch the full site/office configuration heads
      const configUrl = isOfficeStaff
        ? apiUrl.get_office_salary_head_detail + `?siteId=${siteId}&from=userSalary`
        : apiUrl.get_site_salary_head_detail + `?siteId=${siteId}&from=userSalary`;

      const configRes = await callApi(configUrl, { method: "GET" });
      setIsLoadingUserSalary(false);

      if (configRes?.status === true) {
        // Filter configurations that take input
        const filteredConfigs = configRes.data.filter((i) => {
          const name = i?.salaryhead?.name;
          if (isOfficeStaff) {
            return name === "Basic Salary" || name === "Gross Salary" || (i?.salaryhead?.takeInput && name !== "Daily Wages");
          } else {
            return i?.salaryhead?.takeInput === true;
          }
        });

        // Map configs to form inputs
        const mergedSalary = filteredConfigs.map((config) => {
          // Find if user already has this head saved
          const savedItem = res.data.find(i => {
            const hRel = i?.officesalaryhead || i?.sitesalaryhead;
            return hRel?.id === config.id;
          });

          return {
            id: savedItem?.id, // Keep the saved OfficeSalary/UserSalary ID if exists
            amount: savedItem?.amount || 0,
            sitesalaryhead: config, // Mock relation for rendering labels
            officesalaryhead: config // Mock relation for rendering labels
          };
        });

        setSalary(mergedSalary);

        // Set default form values
        const defaultSalary = mergedSalary.map((item) => {
          const hRel = item?.officesalaryhead || item?.sitesalaryhead;
          return {
            amount: item.amount || 0,
            siteSalaryHeadId: hRel?.id,
          };
        });

        setValue("userSalary", defaultSalary);
      }
    } else {
      setIsLoadingUserSalary(false);
    }
  };

  const onSubmit = (data) => {
    onUpdate(data); // Send to parent
  };

  return (
    <Modal
      className="modal-dialog modal-dialog-scrollable modal-xl modal-dialog-centered"
      isOpen={show}
      toggle={onClose}
    >
      <div className="modal-content">
        <div className="modal-header border-0">
          <h1 className="modal-title fs-3 rajdhani-semibold">Update Salary</h1>
        </div>

        <div className="modal-body p-1">
          <div className="d-flex justify-content-center align-items-start mt-5">
            <div
              className="card border-0"
              style={{ backgroundColor: "#f9fafd" }}
            >
              <div className="px-4 py-3 border-bottom d-flex align-items-center bg-white rounded-top-4">
                <i className="bi bi-wallet2 fs-4 me-2 text-primary"></i>
                <h4 className="mb-0 text-primary">Set Salary Details</h4>
              </div>
              {isLoadingUserSalary ? (
                <div className="d-flex justify-content-center my-5">
                  <Spinner />
                </div>
              ) : (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="px-4 py-4">
                    <div className="row g-4">
                      {salary?.length > 0 &&
                        salary.map((item, index) => {
                          const headRelation = item?.officesalaryhead || item?.sitesalaryhead;
                          const fieldName = `userSalary[${index}].amount`;
                          const error =
                            errorsSalary?.userSalary?.[index]?.amount;
                          const isEarning =
                            headRelation?.salaryhead?.type ===
                            "earning";

                          // console.log(item);

                          return (
                            <div
                              className="col-md-6"
                              key={headRelation?.salaryhead?.id}
                            >
                              <div className="d-flex align-items-start border rounded-3 bg-white shadow-sm p-3 position-relative">
                                <div className="w-100">
                                  <div className="d-flex justify-content-between align-items-center mb-1">
                                    <strong className="text-dark">
                                      {headRelation?.salaryhead?.name}
                                    </strong>
                                    <span
                                      className={`badge text-capitalize bg-${isEarning
                                          ? "success-subtle"
                                          : "danger-subtle"
                                        } text-${isEarning ? "success" : "danger"
                                        } fw-semibold`}
                                    >
                                      {headRelation?.salaryhead?.type}
                                    </span>
                                  </div>

                                  <label
                                    htmlFor={fieldName}
                                    className="form-label fw-semibold small text-muted"
                                  >
                                    Amount
                                  </label>
                                  <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    className={`form-control ${error ? "is-invalid" : ""
                                      }`}
                                    id={fieldName}
                                    defaultValue={item?.amount}
                                    min={0}
                                    {...registerSalary(
                                      `userSalary.${index}.amount`,
                                      {
                                        required: true,
                                        min: 0,
                                      },
                                    )}
                                    placeholder={`Enter amount`}
                                  />
                                  {error && (
                                    <div className="invalid-feedback">
                                      Please enter a valid amount for{" "}
                                      {headRelation?.salaryhead?.name}.
                                    </div>
                                  )}

                                  <input
                                    type="hidden"
                                    {...registerSalary(
                                      `userSalary.${index}.siteSalaryHeadId`,
                                    )}
                                    value={headRelation?.id}
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>

        <div className="modal-footer p-4 border-0">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Close
          </button>

          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit(onSubmit)}
            disabled={isLoading}
          >
            {isLoading ? <Spinner /> : "Update"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EditSalaryModal;
